import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Multiselect from 'multiselect-react-dropdown';
import { useTranslation } from 'react-i18next';
import OwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import _ from 'lodash';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import BGImage11 from '../assets/fe/images/menubg.png';

import { API } from '../Helpers/ApiService';
import { DOMAIN_URL } from '../Helpers/Constants';
import { URL } from '../Helpers/URL';
import { RoutesPath } from '../Routes';

const ContentPage = () => {
    const { t, i18n } = useTranslation();
    let { id } = useParams();
    const navigate = useNavigate();
    const auth = useSelector(state => state.auth);
    const [searchParams] = useSearchParams();

    const [data, setData] = useState(null);
    const [form, setForm] = useState({});
    const [formLoading, setFormLoading] = useState(false);
    const [addons, setAddons] = useState([]);

    useEffect(() => {
        if (id) {
            setData(null);
            API({
                url: URL.GET_PAGE + id,
                method: 'GET',
            }).then(res => {
                if (res?.code) {
                    navigate(`/404`);
                    return;
                }
                // document.title = res?.pageTitle[auth.language]
                setData(res);
                setFormData('support', [{
                    addon: '',
                    otherDetails: ''
                }]);
            });

        } else {
            navigate(`/404`);
        }
    }, [id]);

    useEffect(() => {
        getData();
    }, [auth.language]);

    const getData = () => {
        API({
            url: URL.REGISTER_DATA,
            method: 'GET',
        }).then(res => {
            if (res?.code) {
                toast.error(res.message);
                return;
            }
            setAddons([]);
            let addOns = [];
            res?.addons?.map(e => {
                addOns.push({ id: e.id, addon: e.addon[auth.language] });
            })
            setAddons(addOns);
        });
    }

    const setFormData = (name, value) => {
        let data = _.cloneDeep(form);
        data[name] = value;
        setForm(data);
    }

    const setSupportData = (name, index, value) => {
        let data = _.cloneDeep(form);
        if (name == 'addon') {
            if (data['support'].find(e => e[name] == value)) {
                toast.error('Already selected!');
                return;
            }
        }
        data['support'][index][name] = value;
        setForm(data);
    }

    const addSupportData = () => {
        let data = _.cloneDeep(form);
        data['support'].push({
            addon: '',
            otherDetails: ''
        });
        setForm(data);
    }

    const removeSupportData = (index) => {
        let data = _.cloneDeep(form);
        data['support'].splice(index, 1);
        setForm(data);
    }

    const handleSubmitSupport = () => {
        setFormLoading(true);
        API({
            url: URL.SUPPORT,
            method: 'POST',
            data: form
        }).then(res => {
            setFormLoading(false);
            if (res?.code) {
                toast.error(res.message)
                return;
            }
            toast.success('Message sent successfully!');
            setForm({
                support: [{
                    addon: '',
                    otherDetails: ''
                }]
            });
        });
    }

    return (
        <>
            <section className="page-title content-page-title" style={searchParams.get('hidelayout') ? { backgroundImage: "url(" + BGImage11 + ")", marginTop: 0 } : { backgroundImage: "url(" + BGImage11 + ")" }} >
                <div className="anim-icons full-width">
                    <span className="icon icon-bull-eye"></span>
                    <span className="icon icon-dotted-circle"></span>
                </div>
                <div className="auto-container">
                    <div className="title-outer">
                        <h1>{data?.pageTitle[auth.language]}</h1>
                        {/* <ul className="page-breadcrumb">
                            <li><Link to={RoutesPath.Home.path}>{t('home')}</Link></li>
                            <li>{data?.pageTitle[auth.language]}</li>
                        </ul> */}
                    </div>
                </div>
            </section>
            <section className="about-section-two">
                <div className="auto-container">
                    <div className="row">
                        <div className="content-column col-lg-12 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <div className="sec-title">
                                    <span className="sub-title">{data?.pageTitle[auth.language]}</span>
                                    <h2>{data?.title[auth.language]}</h2>
                                    <span className="divider"></span>
                                    {
                                        data?.image ? <figure className="image mt-2 text-center"><img src={DOMAIN_URL + data?.image} alt="" /></figure> : null
                                    }

                                    <div className="text cms-text" dangerouslySetInnerHTML={{ __html: data?.content[auth.language] }}>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {
                data?.type == 'Support' ? (
                    <section className="about-section-two pt-1">
                        <div className="auto-container">
                            <div className="sec-title text-center mb-5">
                                <h2>{t('support_service')}</h2>
                                <span className="divider mt-2"></span>
                            </div>
                            <div className="contact-form">
                                <form>
                                    <div className="row clearfix">
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <div className="input-outer">
                                                <input type="text" name="name" placeholder={t('name')} onChange={e => setFormData('name', e.target.value)} value={form?.name ?? ''} />
                                                <span className="icon fa fa-user"></span>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <div className="input-outer">
                                                <input type="email" name="email" placeholder={t('email')} required="" onChange={e => setFormData('email', e.target.value)} value={form?.email ?? ''} />
                                                <span className="icon fa fa-envelope"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row clearfix">
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <div className="input-outer">
                                                <input type="text" name="phone" placeholder={t('phone')} required="" onChange={e => setFormData('phone', e.target.value)} value={form?.phone ?? ''} />
                                                <span className="icon fa fa-phone"></span>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <div className="input-outer">
                                                <input type="text" name="message" placeholder={t('message')} required="" onChange={e => setFormData('message', e.target.value)} value={form?.message ?? ''} />
                                                <span className="icon fa fa-envelope"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row clearfix mt-4 mb-1">
                                        <h5>{t('support_requirement')}</h5>
                                    </div>
                                    {
                                        form?.support?.map((element, index) => <div key={index} className="row clearfix mb-2">
                                            <div className="col-lg-6 col-md-6 col-sm-12 form-group" style={{ marginBottom: 0 }}>
                                                <div className="input-outer">
                                                    <select value={element.addon} onChange={(e) => setSupportData('addon', index, e.target.value)}>
                                                        <option value={''} hidden disabled>{t('select_support_requirement')}</option>
                                                        {
                                                            addons.map((e, i) => <option key={i} value={e.id}>{e.addon}</option>)
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-5 col-md-5 col-sm-11 form-group" style={{ marginBottom: 0 }}>
                                                <div className="input-outer">
                                                    <input type="text" name="other_details" placeholder={t('other_details')} required="" value={element.otherDetails} onChange={(e) => setSupportData('otherDetails', index, e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-lg-1 col-md-1 col-sm-1 form-group d-flex align-items-center">
                                                {
                                                    index === (form?.support?.length - 1) ? <button type='button' className='btn-style-one support-btn' style={{ padding: '10px 20px' }} onClick={addSupportData}>+</button> : <button type='button' className='btn-style-two support-btn' style={{ padding: '10px 22px' }} onClick={() => removeSupportData(index)}>-</button>
                                                }

                                            </div>
                                        </div>)
                                    }

                                    <div className="row clearfix">
                                        <div className="col-lg-12 col-md-12 col-sm-12 form-group text-right mt-5">
                                            <button className="theme-btn btn-style-one" onClick={handleSubmitSupport} type="button" disabled={formLoading} name="submit-form"><span className="btn-title">{t('submit_now')}</span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                ) : null
            }
            {
                data?.sliderImages.length ? <section className="about-section-two pt-lg-0">
                    <div className="auto-container">
                        <div className="row">
                            <div className="col-12">
                                <OwlCarousel
                                    className='owl-carousel owl-theme content-slider'
                                    loop
                                    margin={10}
                                    dots={true}
                                    items={3}
                                    nav={true}
                                    autoplay
                                    autoplayTimeout={4000}
                                    smartSpeed={450}
                                >
                                    {
                                        data?.sliderImages.map((e, i) => <div key={i} className='item'>
                                            <img className='img-responsive' src={DOMAIN_URL + e} />
                                        </div>)
                                    }

                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </section> : null
            }
        </>
    );
}
export default ContentPage;
